import { useState } from "react";

const useConfirmationDialog = () => {
  const [dialogOpen, setDialogOpen] = useState(false);

  const open = () => setDialogOpen(true);
  const close = () => setDialogOpen(false);

  return { dialogOpen, open, close };
};

export default useConfirmationDialog;